import Vue from 'vue'
import VueRouter from 'vue-router'
import exhibition from './exhibition'
import exhibitor from './exhibitor'
import system from './system'
import portal from './portal'
import login from './login'
Vue.use(VueRouter)


const router = new VueRouter({
  // mode: 'history',
  routes: [
    ...exhibition,
    ...exhibitor,
    ...system,
    ...portal,
    ...login
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js